import React from "react";
import { Link } from "react-router-dom";
import {
  FaFacebook,
  FaTwitter,
  FaLinkedin,
  FaLocationDot,
  FaEnvelope,
  FaHeart,
} from "react-icons/fa6";

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-green-950 text-stone-300 border-t border-stone-900/60 pt-16 pb-8 px-4 sm:px-6 lg:px-8">
      <div className="max-w-7xl mx-auto w-full">
        {/* Main Grid Structure */}
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 pb-12 border-b border-stone-800">
          {/* Column 1: Brand Identity & Motto (5 Columns wide on desktop) */}
          <div className="md:col-span-5 space-y-4">
            <h3 className="text-xl font-black tracking-tight text-white">
              Mohammodia Baria Jam E Masjid
            </h3>
            <p className="text-sm text-stone-400 leading-relaxed max-w-sm">
              Nurturing faith, building unity, and serving our community. Join
              us in making a difference through your prayers, presence, and
              generous support.
            </p>
            {/* Social Links Row */}
            <div className="flex space-x-4 pt-2">
              <a
                href="#"
                className="w-9 h-9 rounded-xl bg-white/5 flex items-center justify-center text-stone-300 hover:bg-white/10 hover:text-white transition-all duration-200"
              >
                <FaFacebook size={18} />
              </a>
              <a
                href="#"
                className="w-9 h-9 rounded-xl bg-white/5 flex items-center justify-center text-stone-300 hover:bg-white/10 hover:text-white transition-all duration-200"
              >
                <FaTwitter size={18} />
              </a>
              <a
                href="#"
                className="w-9 h-9 rounded-xl bg-white/5 flex items-center justify-center text-stone-300 hover:bg-white/10 hover:text-white transition-all duration-200"
              >
                <FaLinkedin size={18} />
              </a>
            </div>
          </div>

          {/* Column 2: Quick Links Navigation (3 Columns wide on desktop) */}
          <div className="md:col-span-3 space-y-4">
            <h4 className="text-xs font-bold uppercase tracking-widest text-emerald-500">
              Quick Links
            </h4>
            <ul className="space-y-2.5 text-sm">
              <li>
                <Link to="/" className="hover:text-white transition-colors">
                  Home
                </Link>
              </li>
              <li>
                <Link
                  to="/about"
                  className="hover:text-white transition-colors"
                >
                  About Us
                </Link>
              </li>
              <li>
                <Link
                  to="/gallery"
                  className="hover:text-white transition-colors"
                >
                  Media Gallery
                </Link>
              </li>
              <li>
                <Link to="/vlog" className="hover:text-white transition-colors">
                  Vlog
                </Link>
              </li>
              <li>
                <Link
                  to="/membership"
                  className="inline-flex items-center gap-1.5 text-emerald-400 hover:text-emerald-300 transition-colors"
                >
                  <FaHeart className="w-3 h-3" /> Become a Member
                </Link>
              </li>
            </ul>
          </div>

          {/* Column 3: Contact Channels (4 Columns wide on desktop) */}
          <div className="md:col-span-4 space-y-4">
            <h4 className="text-xs font-bold uppercase tracking-widest text-emerald-500">
              Contact Details
            </h4>
            <ul className="space-y-4 text-sm">
              <li className="flex items-start gap-3">
                <FaLocationDot className="w-4 h-4 text-emerald-600 mt-0.5 shrink-0" />
                <span className="text-stone-400 leading-snug">
                  Road 1, Kunjo Chaya, Bayezid, Chattogram, Bangladesh
                </span>
              </li>
              <li className="flex items-center gap-3">
                <FaEnvelope className="w-4 h-4 text-emerald-600 shrink-0" />
                <a
                  href="mailto:mohammodiabaria@gmail.com"
                  className="hover:text-white transition-colors break-all"
                >
                  mohammodiabaria@gmail.com
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Section: Copyright & Disclaimer Bar */}
        <div className="pt-8 flex flex-col sm:flex-row items-center justify-between text-xs text-stone-500 gap-4">
          <p>
            &copy; {currentYear} Mohammadia Baria Jam E Masjid. All rights
            reserved.
          </p>
          <p className="flex items-center gap-1">
            Designed for community growth and spiritual transparency.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
